// extracted by mini-css-extract-plugin
module.exports = {"component":"full-teaser_component__HX4xv","row":"full-teaser_row__dBBSO","headline":"full-teaser_headline__R_9T_","column":"full-teaser_column__EKA_R"};